import React from 'react';
import _ from 'lodash';

import {
  selectGeneralTexts,
  selectTexts,
  selectSeoTexts,
  selectTopSectionTexts,
  selectFormTexts,
  selectFormErrors,
  selectCreateHub,
  selectLogin,
} from 'src/store/settings/selectors';
import { useAppSelector } from 'src/hooks/store';

type TranslationSource = 'general' | 'login' | 'createHub' | 'seo' | 'topSection' | 'form' | 'errors';

/**
 * Usage:
 * const { translate } = useTranslation('logIn'); // will use store.settings.texts.{lang}.logIn
 * // assuming: store.settings.texts.{lang}.logIn.hello = 'hello ${name}';
 * const str = translate('hello', { name: 'Dear User' });
 * // -> str = 'hello Dear User
 *
 * If source is not provided translate function will use store.setting.texts.{lang} as base
 */
export const useTranslation = (source?: TranslationSource) => {
  const selectorsMap = {
    general: selectGeneralTexts,
    createHub: selectCreateHub,
    login: selectLogin,
    seo: selectSeoTexts,
    topSection: selectTopSectionTexts,
    form: selectFormTexts,
    errors: selectFormErrors,
  };
  const texts = useAppSelector(source ? selectorsMap[source] : selectTexts);
  const translate = React.useCallback(
    (path: string, options?: Record<string, string>) => {
      let result = _.get(texts, path, path);
      if (options) {
        const compiled = _.template(result);
        result = compiled(options);
      }

      return result;
    },
    [texts],
  );

  return { translate };
};
